import * as React from "react";
import { useNavigate } from "react-router-dom";
import RefIcon from "../../../assets/svg/reficon.svg";
import PointsEarned from "../../../assets/svg/pointsEarnedIcon.svg";
import NewButton from "../../../components/uiMerge/newButton";
import InviteFriends from "../../../assets/svg/inviteFriendss.png";
import { TemplateSub } from "../../../components/layouts/TemplateSub";
import { useReferrerData } from "@njoy/controller";
import { ShareWrapper } from "src/components/shared/Share";
import * as ROUTES from "../../../constants/routes";

export const ReferralPage: React.FC = () => {
  const { data, loading } = useReferrerData();
const navigate = useNavigate();
  const [copied, setCopied] = React.useState(false);

  const handleCopy = async () => {
    if (!data?.referralCode) return;

    await navigator.clipboard.writeText(data.referralCode);
    setCopied(true);

    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <TemplateSub page="Referral">
        <div className="px-4">
          <div className="flex flex-col mt-[14px] mb-10  bg-[#1E1E1E] rounded-xl overflow-hidden">
            {/* <div className="max-w-md mx-auto bg-white rounded-xl shadow-md overflow-hidden md:max-w-2xl p-6 space-y-6"> */}
            <div className="overflow-y-auto p-6">
              {/* Header */}
              <div className=" flex justify-center items-center">
                <img src={InviteFriends} height={69} alt="" />
              </div>

              {/* How it works list */}
              <ul className="space-y-3 text-sm text-gray-700 list-none p-4">
                <li className="flex flex-col gap-1">
                  <div className="flex items-center gap-2">
                    <span>📩</span>
                    <span className="font-extrabold text-white">
                      Share your code
                    </span>
                  </div>
                  <p className="text-white pl-6 font-light opacity-70">
                    Share your unique referral code with friends.
                  </p>
                </li>
                <li className="flex flex-col gap-1">
                  <div className="flex items-center gap-2">
                    <span>🤑</span>
                    <span className="font-extrabold text-white">
                      Earn points
                    </span>
                  </div>
                  <p className="text-white pl-6 font-light opacity-70">
                    You both earn points when they join and connect their ID.
                  </p>
                </li>
              </ul>

              {/* Referral code row */}
              <div className="bg-[#353535] p-4 rounded-lg mt-3">
                <p className="text-sm text-[#C5C5C5] mb-1">
                  Your referral code
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xl font-mono font-bold text-white">
                    {!loading ? data?.referralCode : "loading..."}
                  </span>
                  <NewButton
                    onClick={handleCopy}
                    size="sm"
                    variant="outline"
                    className="px-4 py-1 bg-transparent border border-white text-white text-sm font-medium rounded-[10px] hover:bg-white focus:outline-none focus:ring-0 hover:text-[#C5C5C5]"
                  >
                    {copied ? "Copied!" : "Copy"}
                  </NewButton>
                </div>
              </div>

              {/* Stats */}
              <div className=" flex flex-col mt-6">
                <h3 className="text-[15px] text-center font-semibold text-white mb-3">
                  Your Referral Stats
                </h3>
                <div className="grid grid-cols-2 gap-4">
                  <div className="bg-[#353535] flex flex-col gap-2 p-4 rounded-lg text-left">
                    <img src={RefIcon} height={15} width={15} alt="" />
                    <p className="text-[12px] text-[#C5C5C5]">Referrals</p>
                    <p className="text-[18px] font-bold text-white">
                      {!loading ? data?.referrals : "loading..."}
                    </p>
                  </div>
                  <div className="bg-[#353535] flex flex-col gap-2 p-4 rounded-lg text-left">
                    <img src={PointsEarned} height={15} width={15} alt="" />
                    <p className="text-[12px] text-[#C5C5C5]">Points Earned</p>
                    <p className="text-[18px] font-bold text-white ">
                      {!loading ? data?.referralPoint : "loading..."}
                    </p>
                  </div>
                </div>
              </div>


              {/* Invite button and terms */}

              <ShareWrapper
                shareUrl="https://app.njoy.live"
                shareEmailSubject="Join me on Njoy!"
                quote="Discover Njoy - an amazing platform I use and recommend!"
                hashtag="#Njoy"
                title="Invite to Njoy"
                summary="Try Njoy for exclusive features and a great experience."
                hashtags={["Njoy", "InviteFriends", "Exclusive"]}
                width={125}
              >
                <div className="space-y-2 mt-6">
                  <NewButton type="button" variant="primary" fullWidth>
                    Invite friends
                  </NewButton>
                  <p onClick={() => navigate(ROUTES.TERMS_CONDITIONS)} className="text-xs mt-3 cursor-pointer text-white px-5 underline text-center">
                    By inviting friends, you agree to our terms and
                    conditions.
                  </p>
                </div>
              </ShareWrapper>

              {/* </div> */}
            </div>
          </div>
        </div>
      </TemplateSub>
    </>
  );
};
